import { render, staticRenderFns } from "./ProfileCards.vue?vue&type=template&id=0cd7b837"
import script from "./ProfileCards.vue?vue&type=script&lang=js"
export * from "./ProfileCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports